function scrollToInvalid(form) {
    const invalidInputs = Array.from(form.querySelectorAll(':invalid, .is-invalid'));
    invalidInputs.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
    const firstInvalidInput = invalidInputs[0];

    window.scroll({
        top: firstInvalidInput.getBoundingClientRect().top + window.scrollY - 220,
        behavior: 'smooth'
    });

    window.setTimeout(() => {
        firstInvalidInput.focus();
    }, 500);
}

function handleSubmit(e) {
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
        e.preventDefault();
        e.stopPropagation();

        scrollToInvalid(form);

        window.setTimeout(() => {
            form.reportValidity();
        }, 550);
    }
}

const forms = document.querySelectorAll('form');
forms.forEach(form => {
    form.noValidate = true;
    form.addEventListener('submit', handleSubmit);
});
